module.exports = __webpack_public_path__ + "static/media/vinicius-washington.7775c715.webp";